import React from "react";
import useAuth from "hooks/useAuth";
import { useCountry } from "context/CountryContext";
import AnnouncementsAdminPanel from "components/announcements/admin/AnnouncementsAdminPanel";

// Pop-ups del operador para SUS comercios (pestaña de /admin/notifications).
// El backend acota todo al operador del token y solo deja crear a admin y
// superadmin logístico; acá solo se pasa lo que la vista previa necesita.
export default function ClientPopupsPanel() {
  const { user } = useAuth();
  const { countryCode } = useCountry();
  const logisticCompany = user?.logisticCompany;
  const ownOperator = {
    id: String(logisticCompany?._id ?? user?.logisticCompanyId ?? ""),
    name: logisticCompany?.name ?? null,
    logo: logisticCompany?.logo ?? null,
  };
  return (
    <AnnouncementsAdminPanel
      ownOperator={ownOperator}
      operatorCountryCode={countryCode || "CL"}
    />
  );
}
